// extracted by mini-css-extract-plugin
export default {"scrollbar":"dataprovider_scrollbar__nols+","modal-body-height":"dataprovider_modal-body-height__hFXNK","table-height":"dataprovider_table-height__6oUIx"};